import React, { useState } from 'react'
import { Filters } from 'app/common/filters'
import type { FilterShortDTO } from 'shared/types'
import { injectIntl } from 'react-intl'
import { updateFiltersArray } from 'shared/utils'
import { useStaticStorelocator } from 'shared/store/store-locator'

type Props = {
    applyFilters: (Array<string>) => void,
    resetServices: () => void,
    selectedServices: Array<string>,
    close: () => void,
    clickOutside?: boolean
}

const Services = (props: Props) => {
    const [selectedServices, setSelectedServices] = useState(
        props.selectedServices
    )
    const { data: storeLocatorData } = useStaticStorelocator()

    const availableServices =
        storeLocatorData &&
        storeLocatorData.services &&
        Object.entries(storeLocatorData.services).map(([key, value]) => {
            return {
                code: key,
                name: value,
                iconUrl: null
            }
        })

    const updateFilters = (filter: FilterShortDTO) => {
        const updatedServices = updateFiltersArray(
            [...selectedServices],
            filter.code
        )
        setSelectedServices(updatedServices)
    }

    const resetFilters = () => {
        if (selectedServices.length === 0) {
            return
        }
        props.resetServices()
        setSelectedServices([])
    }

    const filterRestaurants = () => {
        const { close, applyFilters } = props
        applyFilters(selectedServices)
        close()
    }

    const { close, clickOutside = false } = props

    return !!availableServices && !!availableServices.length ? (
        <Filters
            filters={availableServices}
            clickOutside={clickOutside}
            selectedFilters={selectedServices}
            handleReset={resetFilters}
            handleApply={filterRestaurants}
            handleClose={close}
            handleUpdate={filter => updateFilters(filter)}
        />
    ) : null
}

const ServicesComponent = injectIntl(Services)

export { ServicesComponent }
